import {configureStore} from '@reduxjs/toolkit';
import userReducer from "../features/user/userSlice";
import modalsReducer from "../features/modals/modalsSlice";
import notificationsReducer from '../features/notifications/notificationsSlide';
import hipodromosReducer from '../features/hipodromos/hipodromosSlice';
import limitacionesReducer from '../features/limitaciones/limitacionesSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    modals: modalsReducer,
    notifications: notificationsReducer,
    hipodromos: hipodromosReducer,
    limitaciones: limitacionesReducer
  }
})